
import { addContractorReferral } from "@/utils/urlUtils";
import { formatPhoneNumber } from "@/utils/phoneUtils";

interface ContractorContactProps {
  address?: string | null;
  phone?: string | null;
  website?: string | null;
  city: string;
  businessId: string;
  businessName: string;
}

export const ContractorContact = ({ 
  address, 
  phone, 
  website, 
  city,
  businessId,
  businessName
}: ContractorContactProps) => {
  // Check if we have a valid address (not null or "null")
  const hasValidAddress = address && address.toLowerCase() !== 'null';
  const fullAddress = hasValidAddress ? `${address}, ${city}, OK` : null;
  
  // Format phone number if we have one
  const formattedPhone = phone ? formatPhoneNumber(phone) : null;
  
  // Format website URL
  const websiteUrl = website && !website.startsWith('http') 
    ? `https://${website}` 
    : website;

  // Determine if link should be nofollow (all external links except exceptions)
  const shouldNofollow = () => {
    const name = businessName.toLowerCase();
    // Exceptions: Edmond Window Cleaning, Edmond Tree Service (to be renamed to Redbud Tree Service), Evolve Agency
    const exceptions = [
      'edmond window cleaning',
      'edmond tree service',
      'redbud tree service',
      'evolve agency'
    ];
    return !exceptions.some(exception => name.includes(exception));
  };

  const relAttribute = shouldNofollow() 
    ? "noopener noreferrer nofollow" 
    : "noopener noreferrer";

  console.log('ContractorContact rendering with:', {
    address,
    phone: formattedPhone,
    website: websiteUrl,
    city,
    businessId
  });

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold">Contact Information</h3>
      <div className="space-y-2">
        {fullAddress && (
          <p>
            <span className="font-medium">Address:</span> {fullAddress}
          </p>
        )}
        {formattedPhone && (
          <p>
            <span className="font-medium">Phone:</span>{" "}
            <a href={`tel:${phone}`} className="text-primary hover:underline">
              {formattedPhone}
            </a>
          </p>
        )}
        {websiteUrl && (
          <p>
            <span className="font-medium">Website:</span>{" "}
            <a
              href={addContractorReferral(websiteUrl)}
              target="_blank"
              rel={relAttribute}
              className="text-primary hover:underline"
            >
              {websiteUrl}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};
